module.exports = __webpack_public_path__ + "media/assets/images/icon_search-59be872f2e3c746059828a8946eecff4.png";